import { render, staticRenderFns } from "./ImageCanvas.vue?vue&type=template&id=3e322d13&scoped=true&"
import script from "./ImageCanvas.vue?vue&type=script&lang=js&"
export * from "./ImageCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ImageCanvas.vue?vue&type=style&index=0&id=3e322d13&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e322d13",
  null
  
)

export default component.exports